import React, { useState } from 'react'; // Import React and useState hook

// Create a context for managing patient selection state
const PatientContext = React.createContext({
    selectedPatient: '', // Initial state for the selected patient
    setSelectedPatient: () => {}, // Placeholder function for updating selected patient
});

// Export the PatientContext to be used in other components
export default PatientContext;
